import(/* webpackMode: "eager" */ "/codebuild/output/src3440664837/src/patient-app/src/components/loader/Loader.tsx");
